<template>
  <mtd-dropdown style="padding: 0 5px" trigger="click" placement="bottom">
    <div class="lang">
      <mtd-icon name="mtdicon-globe" class="lang-icon"></mtd-icon>
      <mtd-button type="text-primary" class="lang-text-btn">
        {{ langStr }}
      </mtd-button>
      <mtd-icon name="mtdicon-down-thick" class="lang-arrow"></mtd-icon>
    </div>
    <template #dropdown>
      <mtd-dropdown-menu>
        <mtd-dropdown-menu-item
          v-for="item in langConfig"
          :key="item.code"
          :command="item.code"
          @click="changeLang(item)"
        >
          <div
            :class="{ selected: item.code === lang, 'dropdown-item': true }"
          >
            <span class="label">{{ item.name }}</span>
            <mtd-icon
              v-if="item.code === lang"
              name="mtdicon-check"
              class="el-icon-check"
            ></mtd-icon>
          </div>
        </mtd-dropdown-menu-item>
      </mtd-dropdown-menu>
    </template>
  </mtd-dropdown>
</template>
<script>
import { getCookie } from "@osgfe/tools";
import {
    RegionReader,
    RegionUpdater,
    UrlHelper,
} from '@osgfe/web-region-store';

const reportLx = (...args) => {
  if (window.LXAnalytics) {
    window.LXAnalytics(...args);
  }
};

export default {
  name: "McLang",
  props: {
    lxConfig: {
      type: Object,
      default: () => ({}),
    },
  },
  inject: ['$$event'],
  data() {
    return {
      lang: '',
      langConfig: [],
    };
  },
  computed: {
    langStr() {
      return this.langConfig.find((item) => item.code === this.lang)?.name;
    },
  },
  created() {
    // 监听 RegionStore 就绪事件
    if (this.$$event) {
        this.$$event.$on('regionStoreReady', this.initLang);
    }
  },
  mounted() {
    // 兜底：若 regionStoreReady 已在组件挂载前 emit（RegionStore 已有数据），则主动初始化
    const curLang = RegionReader.getCurLang(false)?.code;
    if (curLang) {
      this.initLang();
    }
    console.log("ang:", this.lang);
    reportLx(
      "moduleView",
      this.lxConfig?.initLangBid,
      {
        mis_id: getCookie("msid") || "999",
        locale: this.lang,
      },
      {
        cid: this.lxConfig?.cid,
      }
    );
  },
  methods: {
    changeLang(item) {
      reportLx(
        "moduleClick",
        this.lxConfig?.changeLangBid,
        {
          mis_id: getCookie("msid") || "999",
          locale: item.code,
        },
        {
          cid: this.lxConfig?.cid,
        }
      );
      RegionUpdater.updateLang(item, {
        syncLocalStorage: true,
        syncUrl: true,
        notifyI18nClient: true,
      });
      UrlHelper.clearParams();

      // 刷新页面使新语言生效
      window.location.reload();
    },
    initLang() {
      this.langConfig = RegionReader.getLangOptions();
      this.lang = RegionReader.getCurLang(false)?.code;
    },
  },
};
</script>
<style lang="scss" scoped>
.lang {
  color: #111925;
  display: flex;
  align-items: center;
  margin-inline-end: 24px;
  .lang-text-btn {
    color: #111925;
    margin: 0 4px;
    padding: 0;
    border: none;
  }
  .lang-icon {
    vertical-align: middle;
    font-size: 20px;
  }

  .lang-arrow {
    vertical-align: middle;
    font-size: 18px;
  }
}

.selected {
  color: #00b85c;
  font-weight: 700;
}
</style>